import {
  IConfirmBankingRequest,
  ICreateOrderPayload,
  ICreateOrderResponse,
} from '../../interfaces/order.interface';
import { tmsHTTPRequest } from '../../services/axios/httpRequest';

export const postCreateOrder = (data: ICreateOrderPayload) => {
  return tmsHTTPRequest.post<ICreateOrderResponse>('/v1/orders', data);
};

export const postConfirmBankingOrder = (data: IConfirmBankingRequest) => {
  return tmsHTTPRequest.post<string>(
    `/v1/orders/${data.orderId}/confirm?courseId=${data.courseId}`,
    data
  );
};
